var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.0800781C4.5 0.0800781 0 4.57008 0 10.1001C0 15.1001 3.66 19.2501 8.44 20.0001V13.0001H5.9V10.1001H8.44V7.89008C8.44 5.38008 9.93 4.00008 12.22 4.00008C13.31 4.00008 14.45 4.19008 14.45 4.19008V6.66008H13.19C11.95 6.66008 11.56 7.43008 11.56 8.22008V10.1001H14.34L13.89 13.0001H11.56V20.0001C13.9164 19.6279 16.0622 18.4256 17.6099 16.6101C19.1576 14.7947 20.0054 12.4857 20 10.1001C20 4.57008 15.5 0.0800781 10 0.0800781Z",
    fill: "#6D95FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.4b7b10be4d828f55d62ee9ef1aa80e4a.svg";
export { ForwardRef as ReactComponent };